import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddContentLayer from "../components/AddContentLayer";

const AddContentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Content Details' />

        {/* AddContentLayer */}
        <AddContentLayer />
      </MasterLayout>
    </>
  );
};

export default AddContentPage;